import React, {useEffect, useState} from "react";
import Popup from "../../../../component/Popup/Popup";
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import {ApiUrl} from "../../../../auth/authMethods";
import axios from "axios";
import InstallmentsSwitchForm from "./InstallmentsSwitchForm";
import PopupEdit from "../../../../component/PopupEdit/PopupEdit";

export default function InstallmentsSwitch({orderId, setLoadData}) {

    // Itens de controle de popup
    const [errorMessage, setErrorMessage] = useState("")
    const [errorColumn, setErrorColumn] = useState("")
    const [blockSubmit, setBlockSubmit] = useState(false)

    const button = <>
        <SyncAltIcon fontSize="medium"/>
        &nbsp; Inversão de parcelas
    </>

    const title = "Inversão de parcelas"

    const iconSpan = <>
        <SyncAltIcon fontSize="large" id="icon-svg"/>
        <h3>{title}</h3>
    </>

    // Itens para controle de parcelas
    const url = ApiUrl + '/parcelas/list/' + orderId + '?sort=numero,desc'
    const [parcelList, setParcelList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true)
        axios.get(url)
            .then(function (response) {
                console.log("searching data")
                setParcelList(response.data)
            }).catch(function (errorReceived) {
        }).finally(() => {
            setLoading(false)
        })
    }, [])


    // Controle de variaveis para requisição
    const [parcelaPaga, setParcelaPaga] = useState(null);
    const [parcelaAberta, setParcelaAberta] = useState(null);
    const [files, setFiles] = useState([]);


    const inputs = <InstallmentsSwitchForm
        parcelList={parcelList}
        parcelaPaga={parcelaPaga} setParcelaPaga={setParcelaPaga}
        parcelaAberta={parcelaAberta} setParcelaAberta={setParcelaAberta}
        files={files} setFiles={setFiles}
    />

    const returnData = () => {

        const formData = new FormData();

        // Adiciona cada arquivo no FormData
        files.forEach(file => {
            formData.append('files', file);
        });

        // Adiciona o objeto JSON como Blob
        formData.append('switchInstallmentDto', new Blob([JSON.stringify(
            {
                paidInstallmentId: parcelaPaga,
                openInstallmentId: parcelaAberta
            }
        )], { type: 'application/json' }));

        return formData;
    }

    const headers = {
        'Accept': 'application/json'
    }

    const disableButton = (!(files.length > 0) || parcelaPaga === null || parcelaAberta === null)

    return <PopupEdit
        baseUrl={ApiUrl + '/parcelas/switch'} setLoadData={setLoadData}
        inputs={inputs} title={title} returnData={returnData}
        setErrorMessage={setErrorMessage} setErrorColumn={setErrorColumn}
        buttonClass='dropdown-item' buttonText={button}
        blockSubmit={blockSubmit} headers={headers}
        disableButton={disableButton}
        formClassName={'text-center'}
    />
}